const colors = {
  text: "#444",
  lightText: "#888"
}
export default colors
